import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { User } from 'features/user'
import { useMutation } from 'providers/tanstack-query/useMutation'
import { DELETE_USER } from './api/mutation'
import { Data, Variables } from './api/types'
import { UseDeleteUser, UseDeleteUserProps } from './types'

export const useDeleteUser = ({
  email,
  queriesToInvalidate,
}: UseDeleteUserProps): UseDeleteUser => {
  const { t } = useTranslation('features/user')
  const { enqueueSnackbar } = useSnackbar()

  const { isPending, mutateAsync } = useMutation<{ input: Variables }, Data>({
    mutation: DELETE_USER,
    onCompleted: async (data: Data): Promise<void> => {
      const { deleteUser } = data

      // TODO: 'deleteUser' should never be null in API response. Backend needs to be fixed.
      if (deleteUser?.errors && deleteUser.errors.length > 0) {
        enqueueSnackbar(t('delete.action.error', { email }), { variant: 'error' })
      } else {
        enqueueSnackbar(t('delete.action.success', { email }), { variant: 'success' })
      }
    },
    queriesToInvalidate,
  })

  const deleteUser = (id: User['id']) => {
    void mutateAsync({
      input: {
        userId: id,
      },
    })
  }

  return {
    deleteUser,
    loading: isPending,
  }
}
